export default  {
        data(){
          return {
              isScrollable:false
            }
        }, 
        beforeDestroy() {
        window.removeEventListener('resize',  ()=> this.checkIfScrollable(0, 'resize'));
        },
        mounted(){
            window.addEventListener('resize', ()=> this.checkIfScrollable(0, 'resize'));
            this.checkIfScrollable();
        },
        methods:{
        checkIfScrollable(retryCount = 0, src = "") {
            const MILLISECONDS_IN_SECOND = 1000;
            const timeoutMs = (2 ** retryCount) * MILLISECONDS_IN_SECOND;
            // Diffs smaller than this are browser layout artifacts before the table has fully painted
            const MIN_SIGNIFICANT_DIFF = 20;

            const wrapper = this.$refs.myTable?.$el?.querySelector(".v-data-table__wrapper");

            if (!wrapper || wrapper.scrollWidth === 0 || wrapper.clientWidth === 0 || wrapper.scrollWidth === wrapper.clientWidth) {
                if (retryCount < 10) {
                    setTimeout(() => this.checkIfScrollable(retryCount + 1, src), timeoutMs);
                }
                this.isScrollable = false;
                return;
            }

            const diff = wrapper.scrollWidth - wrapper.clientWidth;

            if (diff < MIN_SIGNIFICANT_DIFF) {
                if (src !== 'resize' && retryCount < 10) {
                    // Initial load with tiny diff means columns haven't fully rendered yet — retry
                    setTimeout(() => this.checkIfScrollable(retryCount + 1, src), timeoutMs);
                    return;
                }
                // On resize a tiny diff is a genuine "not scrollable" state
                this.isScrollable = false;
                return;
            }

            this.isScrollable = true;
        },
        }
    }